export class ResultNoItemMsg {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;

    this.hideClassName = this.node.dataset.hideClass;
  }

  show() {
    this.node.classList.remove(this.hideClassName);
  }

  hide() {
    this.node.classList.add(this.hideClassName);
  }

  render() {
    this.hide();

    // fetch終了かつ有効なスポット情報がなければ
    if (
      !this.app.getState('isFetching') &&
      !this.app.getState('hasValidSpotData')
    ) {
      this.show();
    }
  }
}
